import React from 'react'
import classNamesBind from 'classnames/bind'
import Link from 'next/link'

import { FullAuthUser, SegmentTypes } from '@dashboard/lib/types'
import * as AppConstants from '@dashboard/lib/constants'
import { fullName } from '@dashboard/lib/profile'

import css from './styles.module.scss'
const classNames = classNamesBind.bind(css)

interface OwnProps {
  authUser: FullAuthUser
  pageName: string
  currentSegment: SegmentTypes | null
  hideNotifications?: boolean
  createUserBoolean: (action: string) => void
}

interface State {
  hideInstallCTA: boolean
  hideAddCompany: boolean
  slideUp: boolean
}

export default class NotificationBar extends React.Component<OwnProps, State> {
  constructor(props: OwnProps) {
    super(props)

    this.state = {
      hideInstallCTA: false,
      hideAddCompany: false,
      slideUp: false,
    }
  }

  render() {
    const { hideNotifications, authUser, pageName, currentSegment } = this.props
    const { hideInstallCTA, hideAddCompany, slideUp } = this.state
    const { profile } = authUser

    const showCE =
      !authUser.actions?.dismissed_extension_cta &&
      !authUser.actions?.installed_chrome_extension
    const companyNotDismissed = !authUser.actions?.dismissed_company_cta
    const isLeadership = ['leadership', 'my_personality'].includes(
      currentSegment || '',
    )
    const showCompanyNotification =
      companyNotDismissed &&
      !authUser.company_id &&
      !hideAddCompany &&
      (!currentSegment || isLeadership)
    const skipCE = authUser.role === 'Other' && showCompanyNotification
    const showCENotification =
      showCE &&
      !hideInstallCTA &&
      !skipCE &&
      (!currentSegment || currentSegment === 'sales')
    const shouldHideAssessment =
      currentSegment !== null && !isLeadership && currentSegment !== 'sales'
    const showAssessmentNotification =
      profile &&
      !profile.personality &&
      !hideNotifications &&
      !shouldHideAssessment

    if (authUser.impersonation) {
      return (
        <a
          className={classNames('notification-link', 'red')}
          target="_blank"
          rel="noopener noreferrer"
          href={`${AppConstants.HUB_URL}/users/${authUser.id}`}
        >
          You are impersonating {fullName(authUser.profile)} - {authUser.email}
        </a>
      )
    }

    if (
      ['assessment', 'onboarding'].some(p => {
        return p == pageName
      })
    )
      return null

    if (showCENotification) {
      return (
        <a
          className={classNames('notification-link', { hide: slideUp })}
          target="_blank"
          rel="noopener noreferrer"
          href={AppConstants.CHROME_INSTALL_URL}
        >
          You have not added the Chrome Extension yet. Click here to add it.
          <img
            className={classNames('dismiss')}
            src="/static/share/images/close.svg"
            onClick={this.dismissInstallCTA}
          />
        </a>
      )
    }

    if (showAssessmentNotification) {
      return (
        <Link
          href={'/app/assessment'}
          className={classNames('notification-link')}
          passHref
        >
          You have not taken the assessment yet. Click here to take it.
        </Link>
      )
    }

    if (showCompanyNotification) {
      return (
        <Link
          href="/app/account/settings?add_company=true"
          className={classNames('notification-link', { hide: slideUp })}
          passHref
        >
          Join a company to view your coworkers.
          <img
            className={classNames('dismiss')}
            src="/static/share/images/close.svg"
            onClick={this.dismissAddCompanyCTA}
          />
        </Link>
      )
    }

    return null
  }

  dismissInstallCTA = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
    const { createUserBoolean } = this.props

    e.preventDefault()
    createUserBoolean('dismissed_extension_cta')

    this.setState({ slideUp: true }, () => {
      window.setTimeout(() => {
        this.setState({ hideInstallCTA: true, slideUp: false })
      }, 5000)
    })
  }

  dismissAddCompanyCTA = (
    e: React.MouseEvent<HTMLImageElement, MouseEvent>,
  ) => {
    const { createUserBoolean } = this.props

    e.preventDefault()
    createUserBoolean('dismissed_company_cta')

    this.setState({ slideUp: true }, () => {
      window.setTimeout(() => {
        this.setState({ hideAddCompany: true, slideUp: false })
      }, 5000)
    })
  }
}
